'use client'

import { Pill } from '@ethena/shared-ui/src/components/Pill'
import { CEFI_APY_PERCENTAGE } from '@ethena/shared-ui/src/constants/apy'
import { useSusdeYieldTooltipData } from '@ethena/shared-ui/src/hooks/useSusdeYieldTooltipData'

import { CtaTablet } from '@/components/CtaTablet'
import { SectionHeader } from '@/components/SectionHeader'

export const OnboardingSection = () => {
  const { yieldStr: susdeYieldStr } = useSusdeYieldTooltipData()

  const tabletData = [
    {
      links: [
        {
          alt: 'Ethena',
          href: 'https://app.ethena.fi/',
          image: '/ethena.svg',
        },
        {
          alt: 'Aave',
          href: 'https://aave.com/',
          image: '/aave.svg',
        },
        {
          alt: 'Morpho',
          href: 'https://morpho.org/',
          image: '/morpho.svg',
        },
        {
          alt: 'Pendle',
          href: 'https://www.pendle.finance/',
          image: '/pendle.svg',
        },
      ],
      list: [
        {
          icon: '/shared/sUSDe.svg',
          text: 'Earn on your savings with sUSDe',
        },
        {
          icon: '/telegram-blue.svg',
          text: 'Use USDe in other applications',
        },
      ],
      pills: [`${susdeYieldStr} APY`, 'Airdrops'],
      title: 'DeFi',
    },
    {
      links: [
        {
          alt: 'Bybit',
          href: 'https://www.bybit.com',
          image: '/bybit-white.svg',
        },
        {
          alt: 'Mexc',
          href: 'https://www.mexc.com/',
          image: '/mexc.svg',
        },
        {
          alt: 'Deribit',
          href: 'https://www.deribit.com/',
          image: '/deribit-white.svg',
        },
        {
          alt: 'Hyperliquid',
          href: 'https://app.hyperliquid.xyz/trade',
          image: '/hyperliquid-white.svg',
        },
      ],
      list: [
        {
          icon: '/piggy-bank.svg',
          text: 'USDe as margin collateral',
        },
        {
          icon: '/coins.svg',
          text: 'Deposit into partner earn programs',
        },
      ],
      pills: [`${CEFI_APY_PERCENTAGE}% APY`],
      title: 'Exchanges',
    },
    {
      links: [
        {
          alt: 'Converge',
          href: 'https://www.convergeonchain.xyz/',
          image: '/converge.svg',
        },
        {
          alt: 'Wintermute OTC',
          href: 'https://www.wintermute.com/otc',
          image: '/wintermute.svg',
        },
        {
          alt: 'iUSDe',
          image: '/iusde.svg',
        },
        {
          alt: 'etfetp',
          image: '/etfetp.svg',
        },
      ],
      list: [
        {
          icon: '/institution.svg',
          text: 'USDe exposure via regulated fund',
        },
        {
          icon: '/compliance.svg',
          text: 'KYC & compliance for regulated entities',
        },
      ],
      pills: [`${susdeYieldStr} APY`],
      title: 'Institutional',
    },
  ]

  return (
    <section className="landing-section">
      <div className="landing-layout w-full mx-auto flex flex-col items-center justify-center pt-20 hlg:pt-0">
        <div className="mb-10 w-fit xl:hidden xl:hlg:block">
          <Pill>
            <p className="font-inter">Onboarding</p>
          </Pill>
        </div>
        <SectionHeader title="Ready to Start?" />
        <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 justify-center items-stretch flex-wrap w-full gap-8">
          {tabletData.map((data, index) => (
            <CtaTablet key={index} {...data} />
          ))}
        </div>
      </div>
    </section>
  )
}
